/**
 * OcultarNotasResponsavel
 */
import {$, HttpBody, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import OcultarNotasResponsavelSchema from '@/schema/OcultarNotasResponsavel.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class OcultarNotasResponsavel extends Resource {

  get $schema() {
    return OcultarNotasResponsavelSchema(this)
  }

  get $id() {
    return this.idOcultarNotasResponsavelPk
  }
  set $id(val: ID) {
    this.idOcultarNotasResponsavelPk = val
  }

  get idReponsavelFk() {
    return this.responsavel!.idResponsavelPk
  }
  set idResponsavelFk(value: ID) {
    this.responsavel!.idResponsavelPk = value
  }

  static async persistLoteOcultarNotasResponsavel(
      listToPersist: OcultarNotasResponsavel[], spinner = 'persistLoteOcultarNotasResponsavel') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-ocultar-notas-responsavel`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }
  readonly $name: string = 'OcultarNotasResponsavel'

  readonly $endpoint: string = '/user/ocultar-notas-responsavel{/id}'

  idOcultarNotasResponsavelPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(255)
  razaoSocial: string = ''

  @ValidationRequired()
  @ValidationMaxLength(14)
  cnpj: string = ''

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  ativo: boolean = true

  async persistOcultarNotasResponsavel(spinner = 'persistOcultarNotasResponsavel') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/ocultar-notas-responsavel`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getOcultarNotasResponsavel(id: number | string, spinner = 'getOcultarNotasResponsavel') {
    const fetch = async () => await this.GET(`/user/ocultar-notas-responsavel/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeOcultarNotasResponsavel(id: number, spinner = 'removeOcultarNotasResponsavel') {
    const fetch = async () => await this.DELETE(`/user/ocultar-notas-responsavel/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
